import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    topUp: {
        id: 'cards.actions.top_up',
        defaultMessage: 'Top up',
    },
})
